import React, { useState } from 'react'
import { colors } from 'config/ui'
import { FontIcon, Button } from '@arvoreeducacao/bonsai-ds'
import { useHistory, type RouteComponentProps } from 'react-router-dom'
import useToast from 'utils/hooks/use-toast'
import { LOGIN_PATH } from 'routes/paths'
import { useTranslation } from 'i18n'
import { useRequestPasswordResetMutation } from '__gql-generated__/types'

const RecoverEmailSent = (
  props: RouteComponentProps<unknown, unknown, { email: string }>
) => {
  const toast = useToast()
  const history = useHistory()
  const { t } = useTranslation()
  const [emailLoading, setEmailLoading] = useState(false)
  const [requestPasswordReset] = useRequestPasswordResetMutation()

  const userEmail = props.location.state?.email

  const handleBackToLogin = () => {
    history.push(LOGIN_PATH)
  }

  const handleResendEmail = async () => {
    if (!userEmail || emailLoading) return

    setEmailLoading(true)

    try {
      await requestPasswordReset({ variables: { email: userEmail } })
      toast.toastMessage({
        type: 'success',
        message: 'Email reenviado com sucesso.'
      })

      setEmailLoading(false)
    } catch {
      toast.toastMessage({
        type: 'error',
        message: 'Falha ao reenviar email.'
      })
    } finally {
      setEmailLoading(false)
    }
  }

  return (
    <div className="font-family-base flex h-screen w-full flex-col items-center justify-center pt-0 px-6">
      <div className="flex flex-col items-center md:flex-row gap-20">
        <FontIcon
          iconName="mail-cascade"
          size={200}
          sizeMobile={150}
          color={colors.black2}
        />
        <div className="flex flex-col items-center w-60">
          <h3 className="text-3xl font-bold">{t('Verifique seu e-mail')}</h3>
          {userEmail && (
            <p className="text-lg mb-6 mt-0.5 lg:mb-[50px]">{userEmail}</p>
          )}

          <Button
            fluid
            text={t('Já verifiquei')}
            theme={{ type: 'primaryLivros', size: 'xLarge' }}
            onClick={handleBackToLogin}
          />
          <div className="mt-4">
            <Button
              fluid
              onClick={handleResendEmail}
              text={t('Enviar Novamente')}
              theme={{ type: 'ghost', size: 'large' }}
              loading={emailLoading}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RecoverEmailSent
